import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ROOT } from '@Helpers/apiConfig';
import { createPacerApi } from '@Helpers/pacerApi';
import { MutationResponse, parseMutationResponse } from '../shared.types';
import { FILTERS_QUERY_KEY as BULK_UPDATE_ATTRIBUTE_FILTERS_QUERY_KEY } from '../bulkUpdateAttributes';
import { TaskTag } from './taskTags.types';

// ---- Save Task Tag (create or update) ----

const saveTaskTag = async (taskTag: TaskTag): Promise<MutationResponse> => {
    try {
        const isCreate = taskTag.id === 0;
        const response = isCreate
            ? await createPacerApi().post(`${API_ROOT}task-tags/create`, { json: taskTag }).json()
            : await createPacerApi().put(`${API_ROOT}task-tags/update`, { json: taskTag }).json();
        return parseMutationResponse(response);
    } catch (error) {
        console.error('saveTaskTag API error:', error);
        if (error instanceof Error) {
            throw new Error(`Failed to save task tag: ${error.message}`);
        }
        throw new Error('Failed to save task tag: Unknown error');
    }
};

export const useSaveTaskTag = (
    callback?: (results: MutationResponse) => void
): UseMutationResult<MutationResponse, Error, TaskTag> => {
    const queryClient = useQueryClient();
    return useMutation<MutationResponse, Error, TaskTag>({
        mutationFn: saveTaskTag,
        onSuccess: (mutationResponse) => {
            callback?.(mutationResponse);
            queryClient.invalidateQueries({ queryKey: [BULK_UPDATE_ATTRIBUTE_FILTERS_QUERY_KEY] });
        },
    });
};

export * from './taskTags.types';
